export default "__VITE_ASSET__BOpUD$TW__"